import { render } from "./back.vue?vue&type=template&id=9b4f40a4&scoped=true&ts=true"
import script from "./back.vue?vue&type=script&lang=ts"
export * from "./back.vue?vue&type=script&lang=ts"

import "./back.vue?vue&type=style&index=0&id=9b4f40a4&scoped=true&lang=less"

import exportComponent from "F:\\project\\zifeiluntang\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4f40a4"]])

export default __exports__